import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { CustomHttpParamEncoder } from 'app/core/customHttpParamEncoder';
import { TenantFilter } from 'app/shared/prothesis-base-api-filters/tenant-filter';
import { IndexAllowedCustomerViewModel } from 'app/shared/prothesis-customer-api-view-models/index-allowed-customer.view-model';
import { PickerAllowedCustomerViewModel } from 'app/shared/prothesis-customer-api-view-models/picker-allowed-customer.view-model';
import { ReadAllowedCustomerViewModel } from 'app/shared/prothesis-customer-api-view-models/read-allowed-customer.view-model';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../configuration.service';
import { ReadServiceBase } from '../../read-service-base';

@Injectable({
  providedIn: 'root',
})
export class AuthenticatedCustomerService extends ReadServiceBase<
  ReadAllowedCustomerViewModel,
  IndexAllowedCustomerViewModel,
  TenantFilter
> {
  protected _configurationService: ConfigurationService;

  public constructor() {
    const _configurationService = inject(ConfigurationService);
    const _httpClient = inject(HttpClient);

    super(_httpClient, () => '/Customer/authenticated/Customer/', _configurationService.ProthesisCustomerApiAddress);

    this._configurationService = _configurationService;
  }

  public initializePicker(filter: TenantFilter, sort: string, page: number, pageSize: number): Observable<PickerAllowedCustomerViewModel> {
    if (!filter) {
      filter = new TenantFilter();
    }

    const params = new HttpParams({ encoder: new CustomHttpParamEncoder() })
      .set('filter', JSON.stringify(filter))
      .set('page', page.toString())
      .set('pageSize', pageSize.toString())
      .set('sort', sort);

    return this._httpClient.get<PickerAllowedCustomerViewModel>(`${this._actionUrl}InitializePicker`, { params: params });
  }
}
